// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { postJson } from "./client.jsx";
export const fetchOpeningHistory = (u, o = 0, m, r, g) => postJson("/api/opening-history", {
  initData: u,
  offset: o,
  recorded: m,
  cursor: r,
  deferStats: !0
}, g);
export const fetchOpeningHistoryStats = (u, o) => postJson("/api/opening-history/stats", {
  initData: u
}, o);
